function getFontId(fontName) {
  return btoa(fontName).replace(/=/g, "");
}
function loadGoogleFont(fontName) {
  const urlFontName = fontName.replaceAll(" ", "+");
  const googleFontsUrl = `https://fonts.googleapis.com/css?family=${urlFontName}:400,700`;
  const googleFontsCSS = document.createElement("style");
  googleFontsCSS.id = getFontId(fontName);
  googleFontsCSS.type = "text/css";
  googleFontsCSS.innerHTML = `@import url(${googleFontsUrl});`;
  document.head.appendChild(googleFontsCSS);
}
function googleFontIsLoaded(fontName) {
  const id = getFontId(fontName);
  return !!document.querySelector(`#${id}`);
}

function isCustomFont(store, fontName) {
  return store.getters
    .getStoreVar("Settings", "styling", "text", "customFonts")
    .find((font) => font.name === fontName);
}
async function loadSiteFonts(store) {
  // Custom fonts
  store.getters
    .getStoreVar("Settings", "styling", "text", "customFonts")
    .reduce(async (acc, font) => {
      await acc;
      const fontFamily = font.name.split(".")[0];
      const customFont = new FontFace(fontFamily, `url(${font.url})`);
      try {
        await customFont.load();
        document.fonts.add(customFont);
      } catch (err) {
        console.log(err);
      }
      return acc;
    }, Promise.resolve([]));
  // Site fonts
  ["font", "font2", "font3"].forEach((font) => {
    try {
      const fontName = store.getters.getStoreVar(
        "Settings",
        "styling",
        "text",
        font
      );
      if (
        fontName !== "" &&
        !isCustomFont(store, fontName) &&
        !googleFontIsLoaded(fontName)
      ) {
        loadGoogleFont(fontName);
      }
    } catch (error) {
      console.error(`Failed to load ${font}: ${error.message}`);
    }
  });
}

export { loadSiteFonts, loadGoogleFont };
